/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import ListContainer from "../../../../components/_utils/CommonListView/ListContainer/index.jsx";
import ListTextWithIcon from "../../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer/index.jsx";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";
import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper/index.js";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import TickerAnimation from "../../../../components/_utils/TickerAnimation/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import {
  TaxAddNewLabel,
  taxCompliantViewAll,
  TaxRemoveNewLabel,
} from "../../../../redux/features/accounts/taxAccount/taxAccountViewAll.js";
import {
  beneCategories,
  setToggle,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";

const TaxationAccountViewAll = ({
  id,
  remPan,
  type,
  remAccount,
  flow,
  currentAccountDetails,
  setOpenBeneAssociate,
  remIFSC,
  setModalOpen,
  setTxnPayLoad,
  onAccountSelect,
  popupType,
  cardsType,
  onCardNavigate,
  openBeneAssociate,

  accActiveInactiveState,
  activeInactivePan,
  activeInactiveFlow,
  activeInactiveIfsc,
  activeInactiveBank,
  setFlowSelectedId,
  setIsalertPopup,
  classifiedFlow = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const scrollContainerRef = useRef(null);
  const lastElementRef = useRef();
  const { searchParam, handleSearchParams } = useCustomSearchParams();
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const [Labeldata, setLabeldata] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",") || [],
  );
  const [accountbalancestate, setaccountbalancestate] = useState(
    searchParam.get("sort") || "",
  );
  const [showSearchBar, setShowSearchBar] = useState(false);
  const { services } = useSelector((state) => state.refreshToken);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(
    type === "TaxAcc" || type === "activeInactive"
      ? ""
      : searchParam.get("status") ||
          (location?.state?.approvalStatus === "approved"
            ? "approved"
            : location?.state?.approvalStatus === "pending"
              ? "pending"
              : ""),
  );

  const [currentCategory, setCurrentCategory] = useState("");
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };
  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const [accountNumber, setAccountNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveBank
      : searchParam.get("accno") || "",
  );
  const [isIfsc, setIsIfsc] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveIfsc
      : searchParam.get("ifsc") || "",
  );
  const [panNumber, setPanNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Pan" || activeInactiveFlow === "Existing")
      ? activeInactivePan
      : searchParam.get("pan") || "",
  );
  const [taxType, setTaxType] = useState("");
  const [taxSection, setTaxSection] = useState("");
  const [createdVia, setCreatedVia] = useState(
    searchParam.get("createdVia") || "",
  );
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [totalCount, setTotalCount] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [mainData, setMainData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const filterRef = useRef(null);
  const [isWheelScrolling, setIsWheelScrolling] = useState(false);

  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );

  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labels, setLabels] = useState([]);
  const labelActionDispatchedRef = useRef(false);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);

  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  const fetchData2 = async () => {
    let response;
    let data = [];
    setLoadingData(true);

    switch (active) {
      case "Category":
        response = await dispatch(
          beneCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => itm.includes(searchUserTextDebounce))
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  async function fetchData() {
    setLoading(true);
    try {
      if (currentPage === GlobalConfiguration.lengthCheckOne) {
        setLoading(true);
      }

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        sort_by: accountbalancestate === "Oldest first" ? "oldest" : "latest",
        ...(type === "activeInactive" && {
          associate:
            type === "activeInactive" && accActiveInactiveState === "active"
              ? ["pending", "approved"]
              : type === "activeInactive" &&
                  accActiveInactiveState === "inactive"
                ? ["blocked", "archived", "rejected"]
                : undefined,
        }),
      };

      const addParamsBasedOnSelection = () => {
        if (currentStatus !== "all") {
          queryParams.approval_status = currentStatus;
        }
        if (currentCategory !== "") {
          queryParams.categoryName = currentCategory;
        }
        if (
          startDateFilter !== "" &&
          endDateFilter !== "" &&
          !!startDateFilter &&
          !!endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date =
            startDateFilter + GlobalConfiguration.day_in_seconds;
          queryParams.end_date =
            endDateFilter + GlobalConfiguration.day_in_seconds;
        }

        if (accountNumber !== "" || remAccount) {
          queryParams.bank_account_no = remAccount ? remAccount : accountNumber;
        }

        if (isIfsc !== "" || remIFSC) {
          queryParams.ifsc = remIFSC
            ? remIFSC.toUpperCase()
            : isIfsc.toUpperCase();
        }

        if (panNumber !== "" || remPan) {
          queryParams.pan = remPan
            ? remPan.toUpperCase()
            : panNumber.toUpperCase();
        }

        if (searchUserText !== "") {
          queryParams.search_string = searchUserText;
        }
        if (LabelSearchText?.length !== 0) {
          queryParams.labels = LabelSearchText;
        }
        if (createdVia !== "") {
          queryParams.created_via = createdVia;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(taxCompliantViewAll(queryParams));
      const newData = response?.payload?.tds_accounts || [];
      setMainData(response?.payload);

      if (type === "TaxAcc") {
        setAccumulatedData(
          newData?.filter(
            (itm) =>
              !(
                itm.bank_acc_no === currentAccountDetails?.bank_acc_no &&
                itm.pan_no === currentAccountDetails?.pan
              ),
          ),
        );
      } else {
        setAccumulatedData(newData);
      }

      setTotalCount(
        response?.payload?.total_count || GlobalConfiguration.lengthCheckOne,
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  const onMount = () => {
    // fetchData();
  };

  const handleSelectAll = () => {
    const filteredItems = filteredData.filter(
      (item) => item?.approval_status !== "archived",
    );

    const allIds = filteredItems.map((item) => item.id);

    const isAllSelected = allIds.every((id) => LabelAccounts.includes(id));

    if (isAllSelected) {
      setLabelAccounts([]);
    } else {
      setLabelAccounts(allIds);
    }
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      fetchData();
      labelActionDispatchedRef.current = false;
      setLabelAccounts([]);
      setisLabelClicked(false);
      setShowSearchBar(false);
      setSearchUserText("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
  };

  const handleSubmit = (key, value) => {
    if (type !== "activeInactive") {
      handleSearchParams(key, value);
    }
  };

  const handleDataPopup = (data) => {
    onAccountSelect(
      data?.bank_account_holder_full_name,
      data?.bank_acc_no,
      data?.ifsc_code,
      data?.bank_name,
      data?.category,
      data?.pan_no,
      data?.id,
      data?.labels,
      data?.type_of_account,
      data.tax_section,
    );
    setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountIFSC: data.ifsc_code,
      bankAccountName: data.bank_account_holder_full_name,
      bankAccountNo: data.bank_acc_no,
      bankLogo: data.bank_name,
      beneAccountId: data.id,
      pan: data.pan_no,
      labels: data.labels,
      // settleType: data.settle_type,
    }));
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const handleToggle = (newToggleValue) => {
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
        behavior: "smooth",
      });

      if (!showSearchBar) {
        dispatch(setToggle(newToggleValue));
      }

      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(storedPage));
    toggleDropdown();
  };

  const { storedPage, toggle } = useSelector(
    (state) => state.beneAllVerification,
  );

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
      setIsWheelScrolling(false);
    }
  }, []);

  const handleWheel = useCallback(() => {
    setIsWheelScrolling(true);
  }, []);

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!(startDateFilter && endDateFilter) ||
        (currentStatus !== "all" && !!currentStatus),
    );
  };

  const filteredData = accumulatedData;

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handleClearFilters = () => {
    setCurrentCategory("");
    setStartDateFilter("");
    setEndDateFilter("");
    setCurrentCategory("");
    setAccountNumber("");
    setShowSearchBar(false);
    setSearchUserText("");
    setIsIfsc("");
    setLabelSearchText([]);
    setisLabelClicked(false);
    setCurrentStatus("");
    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    setSearchUserTextDebounce("");
    setPanNumber("");
    setaccountbalancestate("");
    if (type === "activeInactive" && activeInactiveFlow === "Pan") {
      setPanNumber(activeInactivePan);
    } else if (type === "activeInactive" && activeInactiveFlow === "Bank") {
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    } else if (activeInactiveFlow === "Existing") {
      setPanNumber(activeInactivePan);
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    }
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);

    const res = await dispatch(
      TaxAddNewLabel({
        record_ids: toArray(LabelAccounts),
        labels: labelsToAssign,
      }),
    );

    if (TaxAddNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (TaxAddNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    setLoading(false);
    if (TaxAddNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      TaxRemoveNewLabel({
        record_ids: toArray(LabelAccounts),
        labels: labelsToUnassign,
      }),
    );

    if (TaxRemoveNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (TaxRemoveNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
    }

    setLoading(false);
  };

  useEffect(() => {
    if (active?.length) {
      fetchData2();
    }
  }, [active]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);

    setCurrentPage((prevPage) => {
      if (newTotalPages === GlobalConfiguration.lengthCheckZero) {
        return GlobalConfiguration?.lengthCheckOne;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  useEffect(() => {
    dispatch(enableSwitcher());

    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    onMount();
  }, [markerData]);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, [handleKeyDown, handleWheel]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("TaxAvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    scrollContainerRef?.current?.scrollTo(0, 0);
    window.scrollTo(0, 0);
    setLabels(parsedLabels);
  }, [
    currentPage,
    currentStatus,
    currentCategory,
    searchUserText,
    startDateFilter,
    endDateFilter,
    accountNumber,
    pageSize,
    LabelSearchText,
    panNumber,
    isIfsc,
    remAccount,
    remIFSC,
    remPan,
    accountbalancestate,
    accActiveInactiveState,
    createdVia,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    isIfsc,
    currentStatus,
  ]);

  useEffect(() => {
    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
  }, []);

  return (
    <>
      <div
        className={`bg-primary-bg ${type === "TaxAcc" || type === "activeInactive" ? "h-full" : "h-screen"} relative flex flex-col`}
        style={{
          position:
            type === "TaxAcc" || type === "activeInactive" ? "" : "relative",
          overflow: "hidden",
          width:
            type === "TaxAcc" || type === "activeInactive"
              ? ""
              : "var(--full-width)",
        }}
      >
        <div
          className={` ${type === "TaxAcc" || type === "activeInactive" ? " absolute" : "fixed"} bg-primary-nav ${showInnerSearchBar ? "z-z-index-header" : "z-z-index-dropdown"} shadow-box-shadow-top 
                bottom-bottom-base w-full rounded-none
          `}
        >
          {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
            filteredData?.length > GlobalConfiguration.lengthCheckZero && (
              <>
                <div
                  className={`${
                    showInnerSearchBar && "pointer-events-none h-full"
                  }`}
                >
                  {showInnerSearchBar && (
                    <div
                      className={`absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none`}
                    ></div>
                  )}
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={PaginationConfiguration.paginationOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </>
            )}
        </div>

        {isLabelPopupOpen && (
          <div
            onClick={() => {
              setIsLabelPopupOpen(false);
            }}
            className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
          >
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated accounts."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={[
                ...new Map(
                  accumulatedData?.map((item) => [item["id"], item]),
                ).values(),
              ].filter((account) => LabelAccounts.includes(account?.id))}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
            />
          </div>
        )}
        <div
          className={`Label_top_line_of_div w-full hidden `}
          style={{
            zIndex: "var(--z-index-overlay)",
          }}
        >
          <div>
            <p className="w-width-full font-open-sans text-font-xs text-text-primary">
              Only active (pending & approved) accounts are enabled for
              selection.
            </p>
          </div>
        </div>

        <div
          className={` relative ${type === "TaxAcc" || type === "activeInactive" ? "hidden" : "block"} z-z-index-overlay bg-primary-nav `}
        >
          <div>
            <div
              className={`  hidden Qmd:block h-navbar-breadcrumb-height w-full `}
            ></div>
          </div>
        </div>

        <div
          className={`bene_div_container Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act w-full relative `}
        >
          <TopNavComponent
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={
              isLabelClicked
                ? {
                    btnText: `${LabelAccounts?.length ? "Clear" : "Cancel"}`,
                    btnType: "button",
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      const textContent = e.target.textContent.trim();
                      if (textContent === "Clear") {
                        setLabelAccounts([]);
                      }
                      if (textContent === "Cancel") {
                        setisLabelClicked(false);
                      }
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: showSearchBar,
                    hoverOption: "white",
                  }
                : undefined
            }
            topNavCtaBtn2Needed={false}
            handleBack={
              type === "TaxAcc" || type === "activeInactive"
                ? undefined
                : () => {
                    navigate(-1);
                  }
            }
            topNavCtaBtn2Props={
              isLabelClicked
                ? {
                    btnText: "Assign labels",
                    btnType: "button",
                    enabledBgColor: LabelAccounts?.length
                      ? "var(--text-primary)"
                      : "var(--text-disabled)",
                    handleFunction: (e) => {
                      e.stopPropagation();
                      if (LabelAccounts?.length) {
                        setIsLabelPopupOpen(true);
                      }
                    },
                    enabledTextColor: LabelAccounts?.length
                      ? "var(--primary-bg)"
                      : "Var(--text-primary)",
                    isDisabled:
                      isLabelClicked && LabelAccounts?.length ? false : true,
                    hoverOption:
                      isLabelClicked && LabelAccounts?.length
                        ? " white"
                        : "black",
                    inActiveVariantNeeded: true,
                  }
                : undefined
            }
            BottomHeader={
              isLabelClicked
                ? "Select accounts to apply labels. These labels will be used to generate statistics for the associated accounts."
                : undefined
            }
            isSelectionView={isLabelClicked && true}
            isToggleNeeded={true}
            toggleProps={
              !isLabelClicked
                ? {
                    state: toggle,
                    title: toggle ? "Grid View" : "List View",
                    isDisabled: false,
                    ...(!isLabelClicked
                      ? {
                          state: toggle,
                          isDisabled: showSearchBar,
                          handleClick: () => {
                            handleToggle(!toggle);
                          },
                        }
                      : undefined),
                  }
                : undefined
            }
            selectionText={`Account selected - ${LabelAccounts?.length || "0"}`}
            selectionBtnProps={
              isLabelClicked
                ? {
                    btnText: "Select all",
                    btnType: "button",
                    enabledBgColor:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? "var(--positive-bg)"
                        : "var(--primary-nav-act)",
                    handleFunction: () => {
                      handleSelectAll();
                    },
                    inActiveVariantNeeded: true,

                    enabledTextColor: "var(--text-primary)",
                    isDisabled: isLabelClicked ? false : true,
                    hoverOption:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? ""
                        : "white",

                    icon:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                        : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg",
                  }
                : undefined
            }
            assignLabelNeeded={true}
            assignTagNeeded={true}
            assignLabelProps={
              !isLabelClicked
                ? {
                    handleFunction: () => {
                      if (
                        flow === "create" ||
                        type === "TaxAcc" ||
                        type === "activeInactive"
                      ) {
                        actionRestricted();
                        return;
                      }
                      if (
                        services?.includes("ALabel") &&
                        services?.includes("RLabel")
                      ) {
                        if (showSearchBar) {
                          return;
                        }
                        // toast.info("Feature coming soon!", toast_position);
                        setisLabelClicked((prev) => {
                          if (prev) {
                            setLabelAccounts([]);
                          }
                          return !prev;
                        });
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ALabel,RLabel",
                          },
                        });
                      }
                    },
                    isDisabled:
                      showSearchBar ||
                      flow === "create" ||
                      type === "TaxAcc" ||
                      type === "activeInactive",
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,
                    hoverOption: "white",
                    buttonRef: null,
                    title:
                      "Labels will be used to generate statistics for the associated accounts",
                  }
                : undefined
            }
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: loading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search tax account",
              filterPlaceholder:
                "name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("search", val);
                    setSearchUserText(val);
                  },
                  isDropdown: false,
                  isDisabled: loading,
                },
                {
                  name: "Account number",
                  short_name: "Tax A/c",
                  isMulti: false,
                  value:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? activeInactiveBank
                      : popupType === "associated"
                        ? remAccount
                        : remAccount !== "" &&
                            type === "TaxAcc" &&
                            flow !== "create"
                          ? remAccount
                          : accountNumber,
                  setValue: (val) => {
                    handleSubmit("accno", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setAccountNumber(val);
                  },
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remAccount !== "" &&
                          type === "TaxAcc" &&
                          flow !== "create"
                        ? true
                        : false,
                  valueType: "string",
                },
                {
                  name: "IFSC code",
                  short_name: "IFSC",
                  isMulti: false,
                  value:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? activeInactiveIfsc
                      : popupType === "associated"
                        ? remIFSC
                        : remIFSC !== "" &&
                            type === "TaxAcc" &&
                            flow !== "create"
                          ? remIFSC
                          : isIfsc.toUpperCase(),
                  setValue: (val) => {
                    handleSubmit("ifsc", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setIsIfsc(val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remIFSC !== "" && type === "TaxAcc" && flow !== "create"
                        ? true
                        : false,
                },
                {
                  name: "PAN number",
                  short_name: "PAN",
                  isMulti: false,
                  value:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Pan" ||
                      activeInactiveFlow === "Existing")
                      ? activeInactivePan
                      : popupType === "associated"
                        ? remPan
                        : remPan !== "" &&
                            type === "TaxAcc" &&
                            flow !== "create"
                          ? remPan
                          : panNumber.toUpperCase(),
                  setValue: (val) => {
                    handleSubmit("pan", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setPanNumber(val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Pan" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remPan !== "" && type === "TaxAcc" && flow !== "create"
                        ? true
                        : false,
                },
                {
                  name: "Tax type",
                  valueType: "string",
                  short_name: "Typ",
                  isMulti: false,
                  value: taxType,
                  setValue: (val) => {
                    setCurrentPage(1);
                    setTaxType(val);
                  },
                  isDropdown: true,
                  isDisabled: true,
                  isAlphabetical: true,
                },
                {
                  name: "Tax section",
                  valueType: "string",
                  short_name: "Sec",
                  isMulti: false,
                  value: taxSection,
                  setValue: (val) => {
                    setCurrentPage(1);
                    setTaxSection(val);
                  },
                  isDropdown: true,
                  isDisabled: true,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    handleSubmit("label", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setLabelSearchText(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: false,
                },
              ],
              filters: [
                {
                  name: "Account status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: currentStatus,
                  dropdownPlaceHolder: "Select status",
                  isDisabled: type === "activeInactive" ? true : false,
                  options: [
                    "approved",
                    "pending",
                    "rejected",
                    "blocked",
                    "archived",
                  ],
                  statusPop: true,
                  handleChange: (e) => {
                    handleSubmit("status", e);
                    setCurrentStatus(e);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    handleSubmit("date", date);
                    handleDateChange(date);
                  },
                },
                {
                  name: "Created via",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  options: ["Manual", "File upload"],
                  dropdownPlaceHolder: "Select",
                  value: createdVia,
                  // isDisabled: true,
                  handleChange: (val) => {
                    handleSubmit("createdVia", val);
                    setCurrentPage(1);
                    setCreatedVia(val);
                  },
                  statusPop: true,
                },
              ],
              sortByFilter: [
                {
                  name: "Newest first",
                  default: true,
                  isDisabled: false,
                },
                {
                  name: "Oldest first",
                  isDisabled: false,
                },
              ],
              sortValue: accountbalancestate,
              sortHandleChange: (val) => {
                handleSubmit("sort", val);
                setaccountbalancestate(val);
              },
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                currentStatus !== "" ||
                createdVia !== ""
              ),
              isSearchClearAllDisabled:
                type === "activeInactive"
                  ? true
                  : !(
                      accountNumber?.length ||
                      isIfsc?.length ||
                      panNumber?.length ||
                      currentCategory?.length ||
                      LabelSearchText?.length ||
                      searchUserText?.length ||
                      loading
                    ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loadingData: loadingData,
              loading: loading,
              setLoading: setLoadingData,
              isShowFilter: true,
              isShowSortBy: true,
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                ? false
                : true
            }
          />
        </div>
        {!toggle ? (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            className={`z-z-index-content overflow-y-auto ${showInnerSearchBar ? "pointer-events-none" : ""} ${isLabelClicked && " pb-padding-xl mb-margin-xl Qsmd:pb-padding-base  Qsmd:mb-margin-base"}  infinityScrollContainerAccBeneView h-height-full flex-1
            `}
            style={{
              scrollPaddingTop: "var(--padding-md)",
              scrollPaddingBottom: "var(--padding-md)",
              overflow: !isWheelScrolling && "hidden",
              marginBottom: !isWheelScrolling && "var(--margin-base)",
            }}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.preventDefault();

                return false;
              }
            }}
          >
            {showInnerSearchBar && (
              <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-header"></div>
            )}
            {loading ? (
              <div className="loader-container grid place-items-center h-full w-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <div
                className={`scroll flex flex-col items-center h-full-height overflow-y-auto scroll-py-top_md ${showInnerSearchBar && "pointer-events-none opacity-dark-opacity"} w-full ${isLabelClicked ? "mt-margin-sm pt-padding-base" : ""} `}
                ref={scrollContainerRef}
              >
                <div
                  className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md`}
                >
                  {accumulatedData?.map((account) => (
                    <>
                      <CardContainer
                        filterRef={scrollContainerRef}
                        hoverHeight={
                          GlobalConfiguration?.beneScheduleTxnCardHoverHeight
                        }
                        context={account}
                        isSelected={
                          Array.isArray(LabelAccounts) &&
                          LabelAccounts.includes(account.id)
                            ? true
                            : false
                        }
                        isDisabled={
                          id === account?.id
                            ? true
                            : flow === "create"
                              ? ["blocked", "archived", "rejected"].includes(
                                  account?.approval_status,
                                )
                              : isLabelClicked &&
                                account?.approval_status === "archived"
                        }
                        onClickHandler={(e, data) => {
                          if (classifiedFlow) {
                            navigate(
                              `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${account.id}`,
                              { replace: true },
                            );
                            return;
                          }
                          if (type === "activeInactive") {
                            setIsalertPopup(true);
                            setFlowSelectedId(account?.id);
                            return;
                          }
                          if (popupType === "associated")
                            setOpenBeneAssociate(false);
                          if (flow === "create") {
                            handleDataPopup(data);
                            setModalOpen(false);
                          } else {
                            if (cardsType === "ViewOnlyCards") return;
                            if (!isLabelClicked) {
                              if (onCardNavigate) {
                                onCardNavigate(
                                  `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${account.id}`,
                                );
                                return;
                              } else {
                                navigate(
                                  `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${account.id}`,
                                  { replace: openBeneAssociate ? true : false },
                                );
                              }
                              if (type === "TaxAcc") {
                                setOpenBeneAssociate(false);
                              }
                            } else {
                              if (LabelAccounts?.includes(account.id)) {
                                setLabelAccounts(
                                  LabelAccounts.filter(
                                    (id) => id !== account.id,
                                  ),
                                );
                              } else {
                                setLabelAccounts([
                                  ...LabelAccounts,
                                  account.id,
                                ]);
                                setLabeldata([...Labeldata, account]);
                              }
                            }
                          }
                        }}
                      >
                        <card-body>
                          <TextWithIcon
                            type={"text"}
                            text={account.name
                              .toLowerCase()
                              .split(" ")
                              .map(
                                (word) =>
                                  word
                                    .charAt(
                                      GlobalConfiguration?.lengthCheckZero,
                                    )
                                    .toUpperCase() +
                                  word.slice(
                                    GlobalConfiguration?.lengthCheckOne,
                                  ),
                              )
                              .join(" ")}
                            textColor={"var(--text-primary)"}
                            subText={"Account name"}
                            iconComponentArray={[
                              ...(isLabelClicked
                                ? [
                                    {
                                      icon:
                                        Array.isArray(LabelAccounts) &&
                                        LabelAccounts.includes(account.id)
                                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                          : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg",
                                      isDisabled: false,
                                    },
                                  ]
                                : []),
                            ]}
                          />

                          <div className="flex gap-x-gap-sm justify-between items-center">
                            <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
                              <p
                                className={`text-font-sm text-text-primary flex-1 truncate font-normal pl-padding-sm`}
                              >
                                <TickerAnimation
                                  text={standardAccountNumberFormat(
                                    account.bank_acc_no,
                                  )}
                                />
                              </p>
                              <div className="w-full relative flex pl-padding-sm justify-between items-center ">
                                <p
                                  className={`text-font-xs text-text-secondary flex-1 truncate font-normal transform-none`}
                                >
                                  Account number
                                </p>
                              </div>
                            </div>
                            <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
                              <div className="w-banklogo-width-sm h-icon-xs flex-shrink-0">
                                <IfscCodeMapper ifscCode={account?.ifsc_code} />
                              </div>
                            </div>
                          </div>
                        </card-body>
                        <card-hover>
                          <TextWithIcon
                            text={account?.approval_status}
                            subText={"Account status"}
                            textCase={"capitalize"}
                            fontWeight={"semibold"}
                            textColor={getStatusColor(account?.approval_status)}
                          />
                          <TextWithIcon
                            text={
                              account?.labels?.join(", ") ||
                              "No labels assigned"
                            }
                            iconComponentArray={[
                              {
                                icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                              },
                            ]}
                            fontWeight={"normal"}
                            textColor={"var(--text-primary)"}
                          />
                        </card-hover>
                      </CardContainer>
                    </>
                  ))}
                </div>
              </div>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div
                className="flex flex-col items-center justify-center m-auto w-full h-full "
                style={{
                  height: showSearchBar ? " var(--width-full)" : "",
                  overflowY: showSearchBar && "scroll",
                  PointerEvent: showSearchBar && "none",
                }}
              >
                <img
                  src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  alt="No accounts found"
                  className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
                />
                <p
                  className={`text-font-sm text-text-primary items-center ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  {type === "activeInactive" &&
                  accActiveInactiveState === "active"
                    ? "No active associated accounts found."
                    : type === "activeInactive" &&
                        accActiveInactiveState === "inactive"
                      ? "No inactive associated accounts found."
                      : "No data found."}
                </p>
                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active accounts linked to the provided Bank under the tax account classification."
                        : "There are no existing inactive accounts linked to the provided Bank under the tax account classification."}
                    </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active accounts linked to the provided PAN under the tax account classification."
                        : "There are no existing inactive accounts linked to the provided PAN under the tax account classification."}
                    </p>
                  )
                ) : (
                  (currentCategory !== "" ||
                    panNumber !== "" ||
                    accountNumber !== "" ||
                    isIfsc !== "" ||
                    searchUserText !== "" ||
                    isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center  Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        ) : (
          <div
            ref={scrollContainerRef}
            className={`flex-1 overflow-y-auto scroll-py-top_md ${showInnerSearchBar ? " pointer-events-none" : ""} `}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.keyCode === "83" ||
                event.keyCode === "87" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.stopPropagation();
                event.preventDefault();

                return false;
              }
              event.stopPropagation();
            }}
          >
            {showInnerSearchBar && (
              <div class="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content"></div>
            )}
            {loading ? (
              <div className="loader-container grid place-items-center  Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <>
                <div
                  className={`scroll flex flex-col items-center z-z-index-base relative justify-center w-full flex-1 `}
                  ref={filterRef}
                >
                  <div className="standard-list-view-alignment !pt-padding-md">
                    {" "}
                    {accumulatedData.map((item) => (
                      <ListContainer
                        filterRef={scrollContainerRef}
                        hoverHeight={
                          GlobalConfiguration?.beneScheduleTxnCardHoverHeight
                        }
                        key={item.id}
                        onClickHandler={() => {
                          if (classifiedFlow) {
                            navigate(
                              `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${item.id}`,
                              { replace: true },
                            );
                            return;
                          }
                          if (type === "activeInactive") {
                            setIsalertPopup(true);
                            setFlowSelectedId(item?.id);
                            return;
                          }
                          if (popupType === "associated")
                            setOpenBeneAssociate(false);
                          if (flow === "create") {
                            handleDataPopup(item);
                            setModalOpen(false);
                          } else {
                            if (cardsType === "ViewOnlyCards") return;
                            if (!isLabelClicked) {
                              if (onCardNavigate) {
                                onCardNavigate(
                                  `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${item.id}`,
                                );
                                return;
                              } else {
                                navigate(
                                  `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${item.id}`,
                                );
                              }
                              if (type === "TaxAcc") {
                                setOpenBeneAssociate(false);
                              }
                            } else {
                              if (LabelAccounts?.includes(item.id)) {
                                setLabelAccounts(
                                  LabelAccounts.filter((id) => id !== item.id),
                                );
                              } else {
                                setLabelAccounts([...LabelAccounts, item.id]);
                                setLabeldata([...Labeldata, item]);
                              }
                            }
                          }
                        }}
                        isSelected={
                          Array.isArray(LabelAccounts) &&
                          LabelAccounts.includes(item.id)
                        }
                        isDisabled={
                          id === item?.id
                            ? true
                            : flow === "create"
                              ? ["blocked", "archived", "rejected"].includes(
                                  item?.approval_status,
                                )
                              : isLabelClicked &&
                                item?.approval_status === "archived"
                        }
                        context={item}
                      >
                        <list-body>
                          <div className="w-full flex justify-between pr-padding-sm gap-x-gap-sm py-padding-sm">
                            <div
                              className={`flex flex-col gap-y-gap-sm w-full`}
                            >
                              <div className="w-full flex gap-x-gap-sm">
                                <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                                  <CommonBankLogo
                                    variant="small"
                                    ifsc={item.ifsc_code}
                                  />
                                </div>
                                <p className="text-text-primary text-font-xs flex-1 min-w-standard-account-min-width truncate flex font-normal">
                                  <TickerAnimation
                                    text={standardAccountNumberFormat(
                                      item?.bank_acc_no,
                                    )}
                                  />
                                </p>
                                <div className="border-l border-primary-bg"></div>
                                <div className="flex gap-x-gap-sm justify-end items-center">
                                  <p
                                    style={{
                                      color: getStatusColor(
                                        item?.approval_status,
                                      ),
                                    }}
                                    className={` text-font-xs font-semibold capitalize min-w-standard-approval-status-min-width text-right`}
                                  >
                                    {item?.approval_status}
                                  </p>

                                  <img
                                    style={{
                                      display: isLabelClicked ? "flex" : "none",
                                    }}
                                    className="w-icon-sm h-icon-sm flex-shrink-0 cursor-pointer"
                                    src={
                                      Array.isArray(LabelAccounts) &&
                                      LabelAccounts.includes(item.id)
                                        ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                        : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                                    }
                                    alt=""
                                  />
                                </div>
                              </div>
                              <p
                                className={`text-font-xs pl-padding-sm  text-text-primary flex-1 truncate font-normal`}
                              >
                                <TickerAnimation
                                  text={item?.name
                                    .toLowerCase()
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1),
                                    )
                                    .join(" ")}
                                />
                              </p>
                            </div>
                          </div>
                        </list-body>
                        <list-hover>
                          <ListTextWithIcon
                            type={"text"}
                            text={
                              item?.labels?.join(", ") || "No labels assigned "
                            }
                            iconComponentArray={[
                              {
                                icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                              },
                            ]}
                          />
                        </list-hover>
                      </ListContainer>
                    ))}
                  </div>
                </div>
              </>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div
                className="flex flex-col items-center justify-center m-auto w-full h-full"
                style={{
                  height: showSearchBar ? "var(--width-full)" : "",
                  overflowY: showSearchBar && "scroll",
                }}
              >
                <img
                  src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  alt="No accounts found"
                  className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
                />
                <p className="bene-acc-no-beneaccount-text mb-margin-sm">
                  No data found.
                </p>
                {(currentCategory !== "" ||
                  panNumber !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied) && (
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={() => {
                      handleClearFilters();
                    }}
                    enabledTextColor="var(--text-primary)"
                  />
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center  Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        )}

        {/* {isLabelClicked && (
          <div className="h-pagination-height flex-shrink-0 Qmd:hidden block mb-margin-lg"></div>
        )} */}
        <div className="h-pagination-height flex-shrink-0"></div>
        {/* <div
          className={`h-breadcrumb-height flex-shrink-0  ${showInnerSearchBar ? "hidden" : " hidden Qmd:block"} `}
        ></div> */}
      </div>
    </>
  );
};

export default TaxationAccountViewAll;
